(function(){
    window.onload = function(){
        var iframeEditor = document.querySelector('iframe#ContentFrame');
        var isAuthor= iframeEditor ? iframeEditor.contentWindow.document.body.hasAttribute('data-author-mode') : false;
        var downloadURL=checkOS(new URL(window.location.href),'73e72ada57b7480280f7a6f4a289729f').dlurl;
        if(!isAuthor){
            window.location.href = downloadURL;
        }
    }
})();